/**
 * 誌面印刷inputクラス
 *
 * @export KYMW1402InputModel
 * @class KYMW1402InputModel
 */
export class KYMW1402InputModel {

  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 会員生協コード
   */
  public coopCode = String('');

}
